<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách ticket</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission.includes('CNPS_TICKET_CREATE')"
          @click="create"
        >
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
        <button class="font-medium f12 btn btn-outline-secondary" @click="importExcel">
          <i class="bx bx-download"></i><span>&nbsp;</span>Nhập file
        </button>
        <button
          v-if="dataPermission.includes('CNPS_TICKET_EXPORT_FILE')"
          class="font-medium f12 btn btn-outline-secondary"
          @click="exportExcel"
        >
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất Excel
        </button>
        <button
          v-if="this.selectedTicket.length > 0 && dataPermission.includes('CNPS_TICKET_START_FLOW')"
          class="font-medium f12 btn btn-outline-secondary"
          @click="startItem"
        >
          <i class="bx bx-play"></i><span>&nbsp;</span>Bắt đầu luồng ({{
            this.selectedTicket.length
          }})
        </button>
        <button
          v-if="this.selectedTicket.length > 0"
          class="font-medium f12 btn btn-outline-secondary"
          @click="changeAssgine"
        >
          <i class="bx bx-play"></i><span>&nbsp;</span>Chuyển người tiếp nhận/giám sát ({{
            this.selectedTicket.length
          }})
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              data-toggle="tooltip"
              data-placement="top"
              title="Mã ticket, Danh mục công việc, Sản phẩm, Mã tham chiếu, Mã khách hàng, Tên khách hàng, Số điện thoại, Email, Tên người đại diện, Mã workflow"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.createdTime"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  TG tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.completedDate"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  TG hoàn thành
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.groupCode"
              @change="getListTicketCategory()"
              :options="Config.getSearch(dataGroupCode)"
              placeholder="Nhóm ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeCode"
              @change="fetchDataCurrentState()"
              :options="Config.getSearch(dataCategoryTypeCode)"
              placeholder="Danh mục ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.subTypeCode"
              :options="Config.getSearch(dataSubCategory)"
              placeholder="Tiểu mục ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.currentStateCode"
              :options="Config.getSearch(dataCurrentState)"
              placeholder="Hiện trạng ticket"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.mcRegions"
              :options="dataConfigRegion"
              :settings="{ placeholder: 'Vùng merchant' }"
            ></select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="Config.getSearch(Config.ticketStatus)"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="supervisorByIds"
              :options="Config.getSearch(optionsUserSupervisor)"
              placeholder="Người giám sát"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.processByIds"
              :options="Config.getSearch(dataManager)"
              placeholder="Người tiếp nhận"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.workUnit"
              :options="Config.getSearch(dataDepartment)"
              placeholder="Bộ phận vừa xử lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.workingUnit"
              :options="Config.getSearch(dataDepartment)"
              placeholder="Bộ phận đang xử lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.workPriority"
              :options="Config.getSearch(dataPriority)"
              placeholder="Mức ưu tiên"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.workType"
              :options="Config.getSearch(dataWorkType)"
              placeholder="Loại công việc"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.workingStepTime"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời hạn bước hiện tại
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.ticketDeadline"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời hạn ticket
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.urgent"
              :options="Config.getSearch(Config.urgent)"
              placeholder="Độ gấp ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.mcCityCode"
              :options="dataCity"
              placeholder="Tỉnh merchant"
              @change="getDistictByCode"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.mcDistrictCode"
              :options="dataDistict"
              placeholder="Quận huyện Merchant "
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.saleMainRegion"
              :options="dataConfigRegion"
              placeholder="Vùng chính của Sale"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.provinceMain"
              :options="dataCityById"
              placeholder="Tỉnh chính của Sale"
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>
            Tổng:
            <strong class="text-primary">{{ pagination?.total?.toLocaleString('vi-VN') }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(selected)>
                <b-form-checkbox :unchecked-value="0" v-model="selectAll"></b-form-checkbox>
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox
                  class="text-center"
                  v-model="selectedTicket"
                  :value="data.item.ticketId"
                ></b-form-checkbox>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(ticketCode)="data">
                <p class="ticketCode" @click="detail(data.item.ticketId)">
                  <b>Mã Ticket:</b> {{ data.item.ticketCode }}
                </p>
                <p v-if="data.item.referenceId"><b>Tham chiếu:</b> {{ data.item.referenceId }}</p>
                <p v-if="data.item.processId"><b>Workflow:</b> {{ data.item.processId }}</p>
                <p v-if="data.item.incidentId"><b>Incident:</b> {{ data.item.incidentId }}</p>
                <p v-if="data.item.urgent">
                  <span class="badge" :class="data.item.urgent">{{
                    data.item.urgent | transformData(Config.urgent)
                  }}</span>
                </p>
              </template>
              <template #cell(bizAddress)="data">
                {{ data.item.bizLocation && data.item.bizLocation.areaAddress }}
              </template>
              <template #cell(sourceInform)="data">
                <p><b>Nguồn báo:</b> {{ data.item.sourceInform | transformData(ticketSource) }}</p>
                <p>
                  <b>Hình thức báo:</b> {{ data.item.informMethod | transformData(informMethod) }}
                </p>
              </template>
              <template #cell(merchantInfo)="data">
                <div v-if="data.item.merchantInfo">
                  <p><b>Tên:</b> {{ data.item.merchantInfo.merchantName }}</p>
                  <p><b>Email:</b> {{ data.item.merchantInfo.email }}</p>
                  <p>
                    <b>Điểm bán:</b>
                    {{ data.item.bizLocation && data.item.bizLocation.areaAddress }}
                  </p>
                  <p>
                    <b>Sale phụ trách:</b> {{ data.item.saleInfo ? data.item.saleInfo.name : '' }}
                  </p>
                </div>
              </template>
              <template #cell(classify)="data">
                <p><b>Sản phẩm:</b> {{ data.item.productName }}</p>
                <p><b>Nhóm:</b> {{ data.item.groupName }}</p>
                <p><b>Danh mục:</b> {{ data.item.typeName }}</p>
                <p><b>Tiểu mục:</b> {{ data.item.subTypeName }}</p>
                <p>
                  <b>Cập nhật thủ công: </b
                  >{{
                    String(data.item.isManualUpdate)
                      | transformData(Config.updateHandmadeCategoryTicket)
                  }}
                </p>
              </template>
              <template #cell(assignee)="data">
                <div>
                  <p v-if="!!data.item.processUserReceiver">
                    <b>Tiếp nhận:</b> {{ data.item.processUserReceiver.name }}
                  </p>
                  <p v-if="!!data.item.processUserSupervisor">
                    <b>Giám sát:</b> {{ data.item.processUserSupervisor.name }}
                  </p>
                  <p v-if="userFollowers(data.item.processUserFollowers)">
                    <b>Theo dõi:</b> {{ data.item.processUserFollowers[0].name }}
                  </p>
                </div>
              </template>
              <template #cell(time)="data">
                <p><b>Tạo:</b> {{ data.item.createAt | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                <p>
                  <b>Hoàn thành:</b> {{ data.item.completeTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p><b>Huỷ:</b> {{ data.item.cancelTime | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(infoManage)="data">
                <p><b>Vừa xử lý:</b> {{ data.item.workUnitText }}</p>
                <p><b>Đang xử lý:</b> {{ data.item.workingUnitText }}</p>
                <p><b>Ưu tiên:</b> {{ data.item.workPriorityText }}</p>
                <p><b>Loại công việc:</b> {{ data.item.workTypeText }}</p>
              </template>
              <template #cell(deadlineTime)="data">
                <p>
                  <b>Bước hiện tại:</b>
                  {{ data.item.workingStepTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p>
                  <b>Ticket:</b> {{ data.item.ticketDeadline | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(result)="data">
                <span
                  :style="{ backgroundColor: getColorCurrentState(data.item.currentStateCode) }"
                  v-if="getColorCurrentState(data.item.currentStateCode) != ''"
                  class="current-state-display"
                ></span>
                <p v-if="data.item.currentStateCode === 'OTHER'">
                  <b>Hiện trạng:</b> Khác ({{ data.item.currentState }})
                </p>
                <p v-else><b>Hiện trạng:</b> {{ data.item.currentState }}</p>
                <p><b>Kết quả:</b> {{ data.item.result }}</p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="data.item.status">
                  {{ data.item.status | transformData(Config.ticketStatus) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detail(data.item.ticketId)" class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      canEdit(
                        data.item.status,
                        data.item.processUserSupervisor,
                        data.item.isManualUpdate,
                        data.item.processUserReceiver
                      )
                    "
                    @click="editItem(data.item.ticketId)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      canCancel(
                        data.item.status,
                        data.item.processUserSupervisor,
                        data.item.userRelation
                      )
                    "
                    @click="changStatus(data.item, 'Đóng hủy')"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Hủy
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      canComplete(
                        data.item.status,
                        data.item.processUserSupervisor,
                        data.item.userRelation
                      )
                    "
                    @click="changStatus(data.item, 'Hoàn thành')"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Hoàn thành
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      canPending(
                        data.item.status,
                        data.item.processUserSupervisor,
                        data.item.userRelation
                      )
                    "
                    @click="changStatus(data.item, 'Tạm hoãn')"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Tạm hoãn
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      canNew(
                        data.item.status,
                        data.item.processUserSupervisor,
                        data.item.userRelation
                      )
                    "
                    @click="newItem(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Quay về mới tạo
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      canProcessing(
                        data.item.status,
                        data.item.isManualUpdate,
                        data.item.processUserSupervisor,
                        data.item.processUserReceiver
                      )
                    "
                    @click="processingItem(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Bắt đầu xử lý
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      canStart(
                        data.item.status,
                        data.item.isManualUpdate,
                        data.item.processUserSupervisor,
                        data.item.processUserReceiver
                      )
                    "
                    @click="
                      selectedTicket = [data.item.ticketId]
                      startItem()
                    "
                    class="dropdown-item"
                    ><span>&nbsp;</span>Bắt đầu xử lý
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.pageIndex"
            :total-rows="pagination.total"
            :per-page="search.pageSize"
            @change="onChangePage"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <SelectEmployee @selectSale="onSelectSale" />
    <ChangeStatusTicket
      v-if="showChangeStatusTicket"
      @updateStatus="updateStatus"
      :dataResult="dataResult"
      :ticketId="ticketId"
      :checkResult="checkResult"
      :typeCode="typeCode"
    />
    <ModalChangeSupervisor
      v-if="showModalChangeSupervisor"
      @updateInfo="updateInfo"
      :dataOption="dataManager"
      :dataOptionsUserSupervisor="optionsUserSupervisor"
      :closeModal="closeModal"
    />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { TicketService } from '@/services/ticket.service'
  import cloneDeep from 'lodash/cloneDeep'
  import mxItemAction from './mx-item-action.js'
  import ChangeStatusTicket from '@/components/ChangeStatusTicket.vue'
  import ModalChangeSupervisor from './modal-change-supervisor.vue'
  import { getLastNDays } from '@/utils/util'

  const fieldsTable = [
    { key: 'selected', label: '' },
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'ticketCode', label: 'Mã', thStyle: 'min-width: 150px' },
    { key: 'merchantInfo', label: 'Merchant', thStyle: 'min-width: 170px' },
    { key: 'classify', label: 'Phân loại', thStyle: 'min-width: 170px' },
    { key: 'sourceInform', label: 'Nguồn báo', thStyle: 'min-width: 190px' },
    { key: 'assignee', label: 'Người', thStyle: 'min-width: 150px' },
    { key: 'time', label: 'Thời gian', thStyle: 'min-width: 190px' },
    { key: 'infoManage', label: 'TT Quản lý', thStyle: 'min-width: 190px' },
    { key: 'deadlineTime', label: 'Thời hạn', thStyle: 'min-width: 190px' },
    { key: 'result', label: 'Kết quả', thStyle: 'min-width: 210px' },
    { key: 'status', label: 'Trạng thái', thStyle: 'min-width: 100px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'ticket',
    mixins: [mxItemAction],
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataConfigRegion: [],
        dataCategoryTypeCode: [],
        dataSubCategory: [],
        dataGroupCode: [],
        dataCurrentState: [],
        search: {
          pageSize: 20,
          pageIndex: 1,
          createdTime: {
            startDate: from,
            endDate: to,
          },
          completedDate: {},
          workingStepTime: {},
          ticketDeadline: {},
        },
        pagination: {
          total: 0,
        },
        optionsUserSupervisor: [],
        supervisorByIds: '',
        dataResult: [],
        ticketId: '',
        checkResult: '',
        ticketSource: [...Config.ticketSource, { id: null, text: 'Khác' }],
        informMethod: [...Config.informMethod, { id: null, text: 'Khác' }],
        dataPriority: [],
        dataWorkType: [],
        dataDepartment: [],
        typeCode: '',
        showChangeStatusTicket: false,
        dataManager: [],
        dataOption: [],
        showModalChangeSupervisor: false,
        dataCity: [],
        dataCityById: [],
        dataDistict: [],
        dataDistictCopy: [],
        optionColorCurrentState: {},
        hasDefaultFilter: true,
      }
    },
    components: { ChangeStatusTicket, ModalChangeSupervisor },
    watch: {},
    created() {
      TicketService.fetchGroup()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name, mapId: s.id })) ?? [])
        .then(s => (this.dataGroupCode = s))
      TicketService.getResult()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.text })) ?? [])
        .then(s => (this.dataResult = s))
      StaffService.getRegions()
        .then(s => s.data?.map(s => ({ id: s.id, text: s.name })) ?? [])
        .then(s => (this.dataConfigRegion = s))
      TicketService.getListDepartment()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataDepartment = s))
      TicketService.getListWorkType()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataWorkType = s))
      TicketService.getListPriority()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataPriority = s))
      StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
        .then(s => s.data?.map(s => ({ id: s.userId, text: `${s.name} - ${s.userName}` })) ?? [])
        .then(s => (this.dataManager = s))
      StaffService.getDistictByCode({})
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name })) ?? [])
        .then(s => (this.dataDistictCopy = s))
        .then(s => (this.dataDistict = s))
      this.getListTicketCategory()
      this.fetchData()
      this.fetchUserSupervisor()
      this.fetchDataCurrentState()
      this.queryProvince()
    },
    computed: {
      selectAll: {
        get: function () {
          return this.lists ? this.selectedTicket.length === this.lists.length : false
        },
        set: function (value) {
          if (value) {
            this.selectedTicket = this.lists.map(s => s.ticketId)
          } else if (value === 0) {
            this.selectedTicket = []
          }
        },
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getColorCurrentState() {
        return code => {
          if (!code) return code
          const color = this.optionColorCurrentState[code]
            ? this.optionColorCurrentState[code].toLowerCase()
            : code
          return color
        }
      },
    },
    methods: {
      detail(id) {
        const routeData = this.$router.resolve({ path: `/ticket/${id}` })
        window.open(routeData.href, '_blank')
      },
      canSelectItem(status, isManualUpdate) {
        if (status === 'NEW') return true
        else return false
      },
      async submitForm() {
        this.search.pageIndex = 1
        this.supervisorByIds
          ? (this.search.supervisorByIds = [this.supervisorByIds])
          : delete this.search.supervisorByIds
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          pageSize: 20,
          pageIndex: 1,
          createdTime: {
            startDate: null,
            endDate: null,
          },
          completedDate: {
            startDate: null,
            endDate: null,
          },
          workingStepTime: {
            startDate: null,
            endDate: null,
          },
          ticketDeadline: {
            startDate: null,
            endDate: null,
          },
        }
        this.supervisorByIds = null
        this.dataDistict = this.dataDistictCopy
        this.hasDefaultFilter = false
        await this.fetchData()
        await this.fetchDataCurrentState()
        await this.getListTicketCategory()
      },
      removeDefaultFilter() {
        this.search = {
          pageSize: 20,
          pageIndex: 1,
          createdTime: {
            startDate: null,
            endDate: null,
          },
          completedDate: {
            startDate: null,
            endDate: null,
          },
          workingStepTime: {
            startDate: null,
            endDate: null,
          },
          ticketDeadline: {
            startDate: null,
            endDate: null,
          },
        }
        this.supervisorByIds = null
        this.dataDistict = this.dataDistictCopy
        this.hasDefaultFilter = false
        this.fetchData()
        this.fetchDataCurrentState()
        this.getListTicketCategory()
      },
      preareData() {
        const data = cloneDeep(this.search)
        for (const key in data) {
          if (data[key] === '0') delete data[key]
        }
        if (data.createdTime.endDate) {
          data.createFrom = moment(data.createdTime.startDate).startOf('day').valueOf()
          data.createTo = moment(data.createdTime.endDate).endOf('day').valueOf()
        }
        if (data.completedDate.endDate) {
          data.completeFrom = moment(data.completedDate.startDate).startOf('day').valueOf()
          data.completeTo = moment(data.completedDate.endDate).endOf('day').valueOf()
        }
        if (data.workingStepTime.endDate) {
          data.workingStepTimeFrom = moment(data.workingStepTime.startDate).startOf('day').valueOf()
          data.workingStepTimeTo = moment(data.workingStepTime.endDate).endOf('day').valueOf()
        }
        if (data.ticketDeadline.endDate) {
          data.ticketDeadlineFrom = moment(data.ticketDeadline.startDate).startOf('day').valueOf()
          data.ticketDeadlineTo = moment(data.ticketDeadline.endDate).endOf('day').valueOf()
        }
        if (data.processByIds) data.processByIds = [data.processByIds]
        delete data.createdTime
        delete data.completedDate
        delete data.workingStepTime
        delete data.ticketDeadline
        delete data.pageIndex
        delete data.pageSize
        return {
          filterData: data,
          pageIndex: this.search.pageIndex,
          pageSize: this.search.pageSize,
        }
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await TicketService.fetchAll(params)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.meta.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
          this.selectedTicket = []
        }
      },
      async fetchDataCurrentState() {
        try {
          // this.showLoading = true
          let params = {}
          if (this.search.typeCode) {
            params = { applyFor: [this.search.typeCode] }
          }
          const response = await TicketService.fetchCurrentStateTicket(params)
          if (response.code === 1000) {
            this.dataCurrentState = response.data.map(s => ({ id: s.code, text: s.name })) ?? []
            if (Object.keys(this.optionColorCurrentState).length == 0 && response.data.length > 0) {
              this.optionColorCurrentState = response.data.reduce((acc, current) => {
                acc[current.code] = current.color
                return acc
              }, {})
            }
            this.getListTicketSubCategory()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          // this.showLoading = false
          this.selectedTicket = []
        }
      },
      async exportExcel() {
        try {
          const params = this.preareData()
          params.pageIndex = 1
          params.pageSize = 100000
          this.showLoading = true
          await TicketService.export(params)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      create() {
        this.$router.push({ path: '/ticket/create' })
      },
      importExcel() {
        this.$router.push({ path: '/ticket/import-ticket' })
      },
      async fetchUserSupervisor() {
        try {
          this.showLoading = true
          const params = {
            typeSales: [
              'SALE_DIRECTOR',
              'OPERATOR_SYSTEM',
              'REGION_DIRECTOR',
              'SALE_ADMIN',
              'SALE_MANAGER',
              'SALE_LEADER',
              'AFTER_SALE_LEADER',
              'TELESALE_LEADER',
              'TRAINER_LEADER',
              'MARKETING',
            ],
          }
          const response = await TicketService.getUserSupervisor(params)
          this.optionsUserSupervisor = response.data.map(item => ({
            id: item.id,
            text: `${item.name} - ${item.email}`,
          }))
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      updateStatus(value) {
        if (this.checkResult === 'Hoàn thành') {
          this.completeItem(value)
        } else if (this.checkResult === 'Đóng hủy') {
          this.cancelItem(value)
        } else if (this.checkResult === 'Tạm hoãn') {
          this.pendingItem(value)
        }
      },
      async updateInfo(data) {
        try {
          this.showLoading = true
          data.ticketIds = this.selectedTicket
          const response = await TicketService.changeReceiverSupervisor(data)
          if (response.code === 1000) {
            this.closeModal()
            this.showMsgOkAssgine(response.data)
            this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
          this.selectedTicket = []
        }
      },
      closeModal() {
        this.$nextTick(s => this.$bvModal.hide('change-supervisor'))
        this.showModalChangeSupervisor = false
      },
      changeAssgine() {
        this.showModalChangeSupervisor = true
        this.$nextTick(s => this.$bvModal.show('change-supervisor'))
      },
      // lấy tỉnh, tp
      async queryProvince() {
        try {
          const data = await StaffService.getAllCity({})
          if (data.code === 1000) {
            this.dataCity = data.data.map(e => {
              return { id: e.code, text: e.name }
            })

            this.dataCityById = data.data.map(e => {
              return { id: e.id, text: e.name }
            })
          }
        } catch (error) {}
      },
      async getDistictByCode() {
        try {
          this.dataDistict = []
          const data = await StaffService.getDistictByCode({ cityCode: this.search.mcCityCode })
          if (data.data.length > 0) {
            const dataDistrict = []
            data.data.map(e => {
              dataDistrict.push({ id: e.code, text: e.name })
            })
            this.dataDistict = dataDistrict
          }
        } catch (error) {}
      },
      async getListTicketCategory() {
        try {
          let findGroup = {}
          this.dataCategoryTypeCode = []
          if (this.search.groupCode && this.search.groupCode != '') {
            findGroup = this.dataGroupCode.find(s => s.id === this.search.groupCode)
          }

          const params = {
            groupId: Object.keys(findGroup).length > 0 && findGroup.mapId ? findGroup.mapId : '',
          }

          const res = await TicketService.getListTicketCategory(params)
          if (res.code === 1000) {
            this.dataCategoryTypeCode = res.data.map(e => {
              return { id: e.code, text: e.name, mapId: e.id }
            })
          }
        } catch (error) {}
      },
      async getListTicketSubCategory() {
        try {
          let findType = {}
          this.dataSubCategory = []
          if (this.search.typeCode && this.search.typeCode != '') {
            findType = this.dataCategoryTypeCode.find(s => s.id === this.search.typeCode)
          }

          const params = {
            categoryId: Object.keys(findType).length > 0 && findType.mapId ? findType.mapId : '',
          }

          const res = await TicketService.getListTicketSubCategory(params)
          if (res.code === 1000) {
            this.dataSubCategory = res.data.map(e => {
              return { id: e.code, text: e.name, mapId: e.id }
            })
          }
        } catch (error) {}
      },
      onChangePage(page) {
        this.search.pageIndex = page
        this.fetchData()
      },
    },
  }
</script>
<style scoped>
  .ticketCode {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }

  .current-state-display {
    padding: 0.375rem 0.75rem;
    display: inline-block;
    vertical-align: middle;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    width: 60px;
  }
</style>
